import React from 'react';
import { motion } from 'framer-motion';
import './style.scss';
import { SOCIAL_LINKS } from '@/constants';

const Services: React.FC = () => {
	const serviceData = {
		'@context': 'https://schema.org',
		'@type': 'Service',
		serviceType: 'Rental Hiace Bandung',
		provider: {
			'@type': 'Organization',
			name: 'Ketaren Transport',
			url: 'https://www.ketarenrental.id',
			logo: 'https://www.ketarenrental.id/logo.webp',
			contactPoint: {
				'@type': 'ContactPoint',
				telephone: SOCIAL_LINKS.WHATSAPP.PHONE,
				contactType: 'Customer Service'
			}
		},
		description:
			'Ketaren Transport provides car rental services with drivers for transportation needs in Bandung and surrounding areas.',
		areaServed: {
			'@type': 'Place',
			name: 'Bandung'
		},
		offers: {
			'@type': 'Offer',
			priceCurrency: 'IDR',
			price: 'Pricing varies based on service'
		},
		additionalType: 'https://schema.org/Service'
	};

	return (
		<motion.section
			className="services"
			initial={{ opacity: 0, y: 50 }}
			whileInView={{ opacity: 1, y: 0 }}
			viewport={{ once: false, amount: 0.25 }}
			transition={{ duration: 0.5, ease: 'easeOut' }}
		>
			<div className="about-info-box">
				<h3>Layanan</h3>
				<p>
					Ketaren Transport menyediakan layanan rental mobil dengan sopir untuk kebutuhan
					transportasi di Bandung dan sekitarnya. Kami menawarkan rental mobil dalam kota
					maupun rental mobil luar kota dengan berbagai pilihan layanan, seperti:
				</p>
				<ul>
					<li>City Tour</li>
					<li>Kunjungan Dinas dan Bisnis</li>
					<li>Wedding Car</li>
					<li>Antar Jemput Bandara</li>
					<li>Dan Layanan Lainnya</li>
				</ul>
			</div>
			<div className="about-info-box">
				<h3>Keunggulan Layanan Kami:</h3>
				<ul>
					<li>Mobil Terbaru dan Modern</li>
					<li>Kendaraan Bersih dan Nyaman</li>
					<li>Driver Sopan dan Berpengalaman</li>
					<li>Harga Terjangkau dan Kompetitif</li>
					<li>Berbagai Pilihan Mobil untuk Setiap Kebutuhan</li>
				</ul>
			</div>

			{/* Adding the schema markup JSON-LD */}
			<script type="application/ld+json">{JSON.stringify(serviceData)}</script>
		</motion.section>
	);
};

export default Services;
